import {Injectable, Injector} from '@angular/core';
import {Circuit, DefaultState, PesTask, PesUser, PesUserUtils, StateProvider} from '@pes/ui';
import {Transition} from '@uirouter/angular';

/**
 * Provides methods to resolve app default states.
 */
@Injectable()
export class AppStateProvider extends StateProvider {

    constructor(protected injector: Injector) {
        super(injector);
    }

    /**
     * @override
     */
    public goToHome(): void  {
        this.state.go(DefaultState.FO_CIRCUITS);
    }
    /**
     * Goes to the specified task.
     *
     * @param {PesTask} task the task to go in.
     * @param {Circuit} circuit the circuit for which to update state.
     */
    public goToTask(task: PesTask, circuit?: Circuit): void {
        const transition: Transition = this.state.transition;
        // Lorsque que le circuit est initialisé depuis l'interface, 'pos' n'est pas présent dans l'URL:
        const pos: number = transition ? transition.params<any>().pos : 1;
        const tpl: number = transition && transition.params<any>().tpl ? transition.params<any>().tpl : 'none';
        this.state.go(DefaultState.TASK, {taskReference: task.reference, stepIdx: 0, docIdx: 0, pos: pos, tpl: tpl});
    }
}



// WEBPACK FOOTER //
// ./src/app/config/provider/state.provider.ts